import {
  GET_ABILITY_STATUS_DETAIL,
  GET_ABILITY_STATUS_DETAIL_ERROR,
  GET_ABILITY_STATUS_DETAIL_SUCCESS,
  GET_VALIDATE_RECALCULATE_BUTTON_SUCCESS,
  GET_VALIDATE_RECALCULATE_BUTTON_ERROR,
  SET_WAITING_LIST_RECALCULATE_PROCESS_ERROR,
  SET_WAITING_LIST_RECALCULATE_PROCESS_SUCCESS
} from './AbilityStatusSection.actions'

const abilityStatusState = {
  abilityDetails: [],
  abilityStatus: '',
  error: undefined,
  loading: true,
  recalculateAbilityButton: {
    isActive: false,
    loading: false,
    error: undefined,
    nextDisplay: null
  }
}

/**
 * The Ability Status Section reducer.
 */
const abilityStatusReducer = (state = abilityStatusState, { payload, type }) => {
  switch (type) {
    case GET_ABILITY_STATUS_DETAIL: {
      return { ...state, loading: true }
    }
    case GET_ABILITY_STATUS_DETAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        abilityStatus: payload.abilityStatus,
        abilityDetails: payload.abilityDetails
      }
    }
    case GET_ABILITY_STATUS_DETAIL_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error
      }
    }
    case GET_VALIDATE_RECALCULATE_BUTTON_ERROR: {
      return {
        ...state,
        recalculateAbilityButton: {
          isActive: false,
          loading: false,
          error: payload.error.reason
        }
      }
    }
    case GET_VALIDATE_RECALCULATE_BUTTON_SUCCESS: {
      return {
        ...state,
        recalculateAbilityButton: {
          isActive: payload.canRecalculate,
          nextDisplay: payload.dateNextRecalculate,
          recalculateHours: payload.recalculateHours,
          loading: false
        }
      }
    }
    case SET_WAITING_LIST_RECALCULATE_PROCESS_ERROR: {
      return {
        ...state,
        recalculateAbilityButton: {
          isActive: false,
          loading: false,
          error: payload.error.reason
        }
      }
    }
    case SET_WAITING_LIST_RECALCULATE_PROCESS_SUCCESS: {
      return {
        ...state,
        recalculateAbilityButton: {
          isActive: payload.canRecalculate,
          loading: false,
          nextDisplay: payload.dateNextRecalculate
        }
      }
    }
    default: {
      return state
    }
  }
}

export default abilityStatusReducer
